import { Interval, Workout } from "./Workout";


export class WorkoutRepository
{
    static Expand: Workout = Object.assign(new Workout(), {
        Name: "Expand",
        Intervals: [
            new Interval("WarmUp", 480, 60, 50),
            new Interval("1A", 180, 95, 75),
            new Interval("1B", 15, 100, 120),
            new Interval("2A", 180, 95, 75),
            new Interval("2B", 30, 105, 120),
            new Interval("3A", 180, 95, 75),
            new Interval("3B", 45, 110, 120),
            new Interval("4A", 180, 95, 75),
            new Interval("4B", 60, 105, 120),
            new Interval("5A", 180, 95, 75),
            new Interval("5B", 75, 100, 120),
            new Interval("Cool Down", 195, 70, 65),
        ]
    });

    static SST = Object.assign(new Workout(), {
        Name: "SST",
        Intervals: [
            new Interval("Warmup", 480, undefined, undefined, [40, 85]),
            new Interval("1A", 240, undefined, 96),
            new Interval("1B", 300, undefined, 88),
            new Interval("2A", 240, undefined, 96),
            new Interval("2B", 300, undefined, 88),
            new Interval("3A", 240, undefined, 96),
            new Interval("3B", 300, undefined, 88),
            new Interval("4A", 240, undefined, 96),
            new Interval("4B", 300, undefined, 88),
            new Interval("Cool Down", 480, undefined, undefined, [75, 40]),
        ]
    });

    static FunSprintsAndFastLegs = Object.assign(new Workout(), {
        Name: "Fun Sprints and Fast Legs",
        Intervals: [
            new Interval("Warm up", 180, undefined, undefined, [35, 55]),
            new Interval(null, 10, undefined, 225),
            new Interval(null, 160, undefined, 88),
            new Interval(null, 10, undefined, 225),
            new Interval(null, 150, undefined, 55),

            new Interval(null, 10, undefined, 225),
            new Interval(null, 160, undefined, 88),
            new Interval(null, 10, undefined, 225),
            new Interval(null, 150, undefined, 55),

            new Interval(null, 10, undefined, 225),
            new Interval(null, 160, undefined, 88),
            new Interval(null, 10, undefined, 225),
            new Interval(null, 150, undefined, 55),

            new Interval(null, 10, undefined, 225),
            new Interval(null, 160, undefined, 88),
            new Interval(null, 10, undefined, 225),
            new Interval("Cool down", 120, undefined, undefined, [55, 35]),
        ]
    });

    static HIITItDontQuitIt = Object.assign(new Workout(), {
        Name: "HIIT It Don't Quit It",
        Intervals: [
            new Interval(null, 135, undefined, 55),
            new Interval(null, 135, undefined, 64),
            new Interval(null, 45, undefined, 125),
            new Interval(null, 120, undefined, 60),
            new Interval(null, 120, undefined, 70),
            new Interval(null, 120, undefined, 80),
            new Interval(null, 120, undefined, 90),
            new Interval(null, 90, undefined, 53),

            ...Repeat(15, 
            new Interval(null, 30, undefined, 115),
            new Interval(null, 15, undefined, 35)),

            new Interval(null, 300, undefined, 53),

            ...Repeat(15,
            new Interval(null, 30, undefined, 115),
            new Interval(null, 15, undefined, 35)),

            new Interval("Cool down", 180, undefined, 54)
        ]
    });

    static AllWorkouts = [
        WorkoutRepository.Expand,
        WorkoutRepository.SST,
        WorkoutRepository.FunSprintsAndFastLegs,
        WorkoutRepository.HIITItDontQuitIt,

        // WorkoutRepository.Expand,
        // WorkoutRepository.SST,
        // WorkoutRepository.Expand,
        // WorkoutRepository.SST,
        // WorkoutRepository.Expand,
        // WorkoutRepository.SST,
        // WorkoutRepository.Expand,
        // WorkoutRepository.SST,
        // WorkoutRepository.Expand,
        // WorkoutRepository.SST,
        // WorkoutRepository.Expand,
        // WorkoutRepository.SST,
        // WorkoutRepository.Expand,
        // WorkoutRepository.SST,
        // WorkoutRepository.Expand,
        // WorkoutRepository.SST
    ];

}

function Repeat(count: number, ...intervals: Array<Interval>): Array<Interval>
{
    let result: Array<Interval> = [];
    for (let i = 0; i < count; i++)
    {
        result.push(...intervals);
    }
    return result;
}
